import { Matrix4, Object3D } from "three";
import ISceneObject from "./ISceneObject";
import ISceneGeometry from "./ISceneGeometry";
import EditHandleData from "../sceneObjectData/EditHandleData";
import EditHandleGeometry from "./EditHandleGeometry";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import PropertyList from "../properties/PropertyList";
import { PropertyId } from "../properties/PropertyId";

export default class EditHandleSceneObject implements ISceneObject {

    data: EditHandleData;
    geometry: ISceneGeometry;

    constructor(data: EditHandleData) {
        this.data = data;
        this.geometry = new EditHandleGeometry();
        this.geometry.update(data, true);
    }

    addToScene(): void {
        this.geometry.addToScene();
    }

    removeFromScene(): void {
        this.geometry.removeFromScene();
    }

    setParent(parent: Object3D | null): void {}

    getWorldMatrix(): Matrix4 {
        this.geometry.group.updateWorldMatrix(true, false);
        return this.geometry.group.matrixWorld.clone();
    }

    clone(detachFromParent: boolean): ISceneObject {
        return new EditHandleSceneObject(this.data.clone());
    }

    // A handle is a transient overlay owned by SelectCmd, never a document object.
    canClone(): boolean {
        return false;
    }

    hasSelectionContextToolbar(): boolean {
        return false;
    }

    onAnnotationDirectionChange(rotationOffset: number): void {}

    setHover(hovered: boolean): void {
        (this.geometry as EditHandleGeometry).setHover(hovered);
    }

    getEditHandles(): EditHandleData[] {
        return [];
    }

    getProperties(_props: PropertyList, _filterId?: PropertyId): void {
    }

    setProperties(_props: PropertyList): void {
    }

    dispose(): void {
        this.geometry.dispose();
    }
}
